import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-banner-slider-showcase',
  templateUrl: './banner-slider-showcase.component.html',
  styleUrls: ['./banner-slider-showcase.component.scss']
})
export class BannerSliderShowcaseComponent implements OnInit, OnDestroy {

  currentIndexSingle = 0;
  currentIndexMulti = 0;
  currentIndexRich = 0;
  currentIndexAuto = 0;
  autoPlayPaused = false;

  singleSlides: SafeHtml[];
  multiSlides: SafeHtml[];
  richSlides: SafeHtml[];
  autoSlides: SafeHtml[];

  private autoPlayTimer: any;
  private readonly AUTO_INTERVAL = 3000;

  constructor(private sanitizer: DomSanitizer) {
    this.singleSlides = [
      sanitizer.bypassSecurityTrustHtml('Only one slide — navigation controls are still rendered.')
    ];

    this.multiSlides = [
      sanitizer.bypassSecurityTrustHtml('Reminder: Submit your Q2 claims before June 30th to ensure timely processing.'),
      sanitizer.bypassSecurityTrustHtml('New promotion available: Cisco Catalyst 9000 double-points event ends July 15th.'),
      sanitizer.bypassSecurityTrustHtml('Platform maintenance scheduled for Sunday 02:00–04:00 UTC. Submissions will be unavailable.')
    ];

    this.richSlides = [
      sanitizer.bypassSecurityTrustHtml('<strong>Action required:</strong> Update your tax information in your profile before July 1st to avoid payout delays.'),
      sanitizer.bypassSecurityTrustHtml('<p>Leaderboard standings updated. Top sellers this quarter:</p><ul><li>Region APAC — 142% attainment</li><li>Region EMEA — 138% attainment</li></ul>'),
      sanitizer.bypassSecurityTrustHtml('<strong>New challenge:</strong> Sell any 3 Cisco Meraki products this month and earn a 500-point bonus.')
    ];

    this.autoSlides = [
      sanitizer.bypassSecurityTrustHtml('<strong>Slide 1:</strong> Submit your Q2 claims before June 30th to ensure timely processing.'),
      sanitizer.bypassSecurityTrustHtml('<strong>Slide 2:</strong> Cisco Catalyst 9000 double-points event — ends July 15th.'),
      sanitizer.bypassSecurityTrustHtml('<strong>Slide 3:</strong> Platform maintenance Sunday 02:00–04:00 UTC. Submissions will be unavailable.')
    ];
  }

  ngOnInit(): void {
    this.startAutoPlay();
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
  }

  prevSingle(): void {
    const total = this.singleSlides.length;
    this.currentIndexSingle = (this.currentIndexSingle - 1 + total) % total;
  }

  nextSingle(): void {
    this.currentIndexSingle = (this.currentIndexSingle + 1) % this.singleSlides.length;
  }

  prevMulti(): void {
    const total = this.multiSlides.length;
    this.currentIndexMulti = (this.currentIndexMulti - 1 + total) % total;
  }

  nextMulti(): void {
    this.currentIndexMulti = (this.currentIndexMulti + 1) % this.multiSlides.length;
  }

  prevRich(): void {
    const total = this.richSlides.length;
    this.currentIndexRich = (this.currentIndexRich - 1 + total) % total;
  }

  nextRich(): void {
    this.currentIndexRich = (this.currentIndexRich + 1) % this.richSlides.length;
  }

  prevAuto(): void {
    const total = this.autoSlides.length;
    this.currentIndexAuto = (this.currentIndexAuto - 1 + total) % total;
    this.resetAutoPlay();
  }

  nextAuto(): void {
    this.currentIndexAuto = (this.currentIndexAuto + 1) % this.autoSlides.length;
    this.resetAutoPlay();
  }

  goToAuto(index: number): void {
    this.currentIndexAuto = index;
    this.resetAutoPlay();
  }

  onAutoDragStart(): void {
    this.stopAutoPlay();
    this.autoPlayPaused = true;
  }

  onAutoDragEnd(): void {
    this.startAutoPlay();
    this.autoPlayPaused = false;
  }

  startAutoPlay(): void {
    if (this.autoSlides.length <= 1) { return; }
    this.autoPlayTimer = setInterval(() => {
      this.currentIndexAuto = (this.currentIndexAuto + 1) % this.autoSlides.length;
    }, this.AUTO_INTERVAL);
  }

  stopAutoPlay(): void {
    clearInterval(this.autoPlayTimer);
  }

  private resetAutoPlay(): void {
    this.stopAutoPlay();
    this.startAutoPlay();
  }
}
